module.exports = __webpack_public_path__ + "media/images/icon-store-search-351312c3801a1ee989ca1281ff762065.svg";